import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import AppUnAuthed from './AppUnAuthed'

const stateToProps = ({ auth }) => ({
  token: auth.token,
  userId: auth.user.id,
})

const dispatchToProps = {
  goTo: url => replace(url),
}

export default connect(stateToProps, dispatchToProps)(AppUnAuthed)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/AppUnAuthed/AppUnAuthed.container.js